import { APP_ID } from "./Constants";

// Wrapper around the fetch API
export default function (
  url,
  params,
  successCallback,
  errorCallback,
  method = "POST"
) {
  let currentVersion = localStorage.getItem("currentVersion");
  let body = params || {};
  body.sender = "web";
  body.appversion = currentVersion;
  body.appid = APP_ID;

  fetch(url, {
    credentials: "include",
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: method === "POST" ? JSON.stringify(body) : undefined
  })
    .then(response => {
      return response.json();
    })
    .then(response => {
      if (response.result !== "success") {
        // if the result isn't successful, errorcallback is called
        // with the error (passing the message directly to the callback, can be changed)
        // errorCallback(response.extras.message);
        // errorCallback(response);
        // return;
        throw new Error(JSON.stringify(response));
        // return new Error(response.extras.message);
      }

      // Runs below code on successful fetch
      if (successCallback !== undefined) {
        successCallback(response);
      }
    })
    .catch(error => {
      // Runs below code on unsuccessful fetch
      console.log(error);
      if (errorCallback !== undefined) {
        errorCallback(JSON.parse(error.message));
      }
    });
}

export const apiCallFetch = (url, method = "GET", body) => {
  let status = 0;
  body = body ? JSON.stringify(body) : undefined;
  return fetch(url, {
    method,
    body,
    headers:
      method === "POST"
        ? {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        : undefined
  })
    .then(res => {
      status = res.status;
      return res.json();
    })
    .then(res => {
      if (status >= 400) {
        throw JSON.stringify(res);
      }
      return res;
    });
};



// WEBPACK FOOTER //
// ./src/utils/PostJSON.js